export const ENV = process.env.REACT_APP_ENV;
export const CROWDIN_DIST = process.env.REACT_APP_CROWDIN_DIST;
export const APPSFLYER_KEY = process.env.REACT_APP_APPSFLYER_KEY;
export const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;
export const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
export const GOOGLE_MEASUREMENT_ID =
  process.env.REACT_APP_GOOGLE_MEASUREMENT_ID;
export const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
